import { ReactComponent as ArrowForwardSvg } from '@dynamika-shared/ui/assets/icons/arrow-forward.svg';
import { QuestionSignIcon } from '@dynamika-shared/ui/icons';
import { twJoin } from 'tailwind-merge';
import { twMerge } from '@utils/twMerge';
import { IntercomInstance } from '../../Intercom.config';

type NeedHelpProps = {
  collapsed: boolean;
};

export const NeedHelp = ({ collapsed }: NeedHelpProps) => {
  return (
    <div
      className={twJoin(
        IntercomInstance.getInstance().custom_launcher_selector,
        ' mx-1 border cursor-pointer transition-all group/image',
        collapsed
          ? 'bg-aliceBlue flex h-[5.6rem] w-[5.6rem] items-center justify-center p-2 rounded-lg '
          : 'bg-needHelp h-[14.6rem] w-[20.6rem] px-[1.9rem] py-[1.5rem] rounded-[2.4rem] '
      )}
    >
      {collapsed && (
        <QuestionSignIcon className='h-3 w-3 group-hover/image:text-vividTangelo' />
      )}
      {!collapsed && (
        <div className=''>
          <div className='mb-1.5 flex'>
            <div className='mr-1'>
              <QuestionSignIcon className='h-3 w-3' />
            </div>
            <h1 className='text-1624 font-medium text-dimGray'>Need help?</h1>
          </div>
          <p className='text-1216'>
            You can find all necessary information or get in contact with the
            team
          </p>
          <div className='relative mt-1 flex w-[10rem] flex-nowrap items-center gap-[12px]'>
            <span
              className={twMerge(
                'text-1424 hidden font-semibold text-vividTangelo group-hover/image:block'
              )}
            >
              Get Help
            </span>
            <ArrowForwardSvg className=' h-3 w-3 transition-all duration-300 group-hover/image:text-vividTangelo' />
          </div>
        </div>
      )}
    </div>
  );
};
